<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
        <HelperNav />
          <div class="dashboard-wrapper">

            <div class="pb-4" style="margin:auto;max-width:600px;">

              <div class="ar-card size-sm over-visible mb-4">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                    سبد دارایی
                  </div>
                </div>
                <div class="ar-card-body p-0">
                  <div class="poster-wrapper">

                    <div class="poster-inner">
                      <div class="poster-text">
                        دارایی تتر و تومان خود را مدیریت کنید.
                      </div>
                      <div class="poster">
                        <img :src="StaticImageUrl+'assets/images/undraw_transfer_money.svg'">
                      </div>
                    </div>

                    <div class="poster-actions">
                      <router-link :to="{name:'Dashboard'}" class="ar-btn size-sm round primary mx-3">ورود </router-link>
                    </div>

                  </div>
                </div>
              </div>

              <div class="ar-card size-sm over-visible mb-4">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                    حساب های بانکی
                  </div>
                </div>
                <div class="ar-card-body p-0">
                  <div class="poster-wrapper">

                    <div class="poster-inner">
                      <div class="poster-text">
                        حساب های بانکی دلخواه خود را اضافه کنید.
                      </div>
                      <div class="poster">
                        <img :src="StaticImageUrl+'assets/images/undraw_savings.svg'">
                      </div>
                    </div>

                    <div class="poster-actions">
                      <router-link :to="{name:'BankAccounts'}" class="ar-btn size-sm round primary mx-3">ورود</router-link>
                    </div>

                  </div>
                </div>
              </div>

              <div class="ar-card size-sm over-visible mb-4">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                    ولت ها
                  </div>
                </div>
                <div class="ar-card-body p-0">
                  <div class="poster-wrapper">

                    <div class="poster-inner">
                      <div class="poster-text">
                        کیف پول های متفاوت به تعداد نامحدود اضافه کنید.
                      </div>
                      <div class="poster">
                        <img :src="StaticImageUrl+'assets/images/undraw_digital_currency.svg'">
                      </div>
                    </div>

                    <div class="poster-actions">
                      <router-link :to="{name:'Wallets'}" class="ar-btn size-sm round primary mx-3">ورود</router-link>
                    </div>

                  </div>
                </div>
              </div>

              <div class="ar-card size-sm over-visible mb-4">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                    امنیت
                  </div>
                </div>
                <div class="ar-card-body p-0">
                  <div class="poster-wrapper">

                    <div class="poster-inner">
                      <div class="poster-text">
                        امنیت حساب خود را بالا ببرید.
                      </div>
                      <div class="poster">
                        <img :src="StaticImageUrl+'assets/images/undraw_security.svg'">
                      </div>
                    </div>

                    <div class="poster-actions">
                      <router-link :to="{name:'Security'}" class="ar-btn size-sm round primary mx-3">ورود</router-link>
                    </div>

                  </div>
                </div>
              </div>
              
              <div class="ar-card size-sm over-visible mb-4">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                    معرفی به دوستان
                  </div>
                </div>
                <div class="ar-card-body p-0">
                  <div class="poster-wrapper">

                    <div class="poster-inner">
                      <div class="poster-text">
                        از معرفی به دیگران درآمد نامحدود و دائمی داشته باشید.
                      </div>
                      <div class="poster">
                        <img :src="StaticImageUrl+'assets/images/undraw_subscriber.svg'">
                      </div>
                    </div>

                    <div class="poster-actions">
                      <router-link :to="{name:'Referral'}" class="ar-btn size-sm round primary mx-3">ورود</router-link>
                    </div>

                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
export default {
  name: 'MyAccount',
  components:{
    Sidebar,
    HelperNav,
    Header,
  },
  data : () => ({
  }),
  methods:{
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
  }
}
</script>